import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';





var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [['Sr No.', 'Trip Id','Bill No',  'sku7_code',  'Product Name', 'upc',  'MRP',  'Free Loose ','Free Cld', 'Loose To Be Picked', 'Cld To Be Picked', 'Dispatched Loose', 'Dispatched cld qty']];





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      bill_no : "",
      sub_group_id :"",

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      filtered_orderData : [],

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }

  ToDateChange = date => {

    this.setState({
      to_date: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",

      })
      to_Date_val = ""
    }

  }
  onBillChange = (evt) => {
    this.setState({
      bill_no: evt.target.value,
    });
  };
  onSubGroupChange = (evt) => {
    this.setState({
      sub_group_id : evt.target.value,
    });
  };
  

  fetchInventoryData() {

    this.setState({
      showFetchBinData: true,
      
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      bill_number : this.state.bill_no,
      sub_group_id :this.state.sub_group_id,
      // request_type: "view",
      // location: this.state.selectedLocation,
      // screen_type : "cld_dispatch_report"
      
    };
    addAnalytics('Report', 'View Billwise Case Picksheet Report', payload);
    API.post('/download/billwise-cld-picksheet-report/', { param: payload })
      .then(response => response.data)

      .then(data => {

        // this.setState({ tableRows: this.assemblePosts(data.data ),orderData : data.data})
      
        // window.location.href = data.data
        console.log(data.data);
        this.setState({
          tableRows: this.assemblePosts(data.data),
          // orderData : data.data

       })

      })

      .then(async () => {

        this.setState({  isLoading: false,loading_overlay: false, })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
    assemblePosts = (data) => {

      let posts = data.map((post) => {
        var status = ""
        if (post.status == true) {
          status = "Active"
        } else { status = " Not Active" }
        return (
  
          {
            sr_no : post.s_no,
            trip_id :post.trip_id,
            bill_no : post.bill_no,
            sku7_code: post.sku7_code,
            product_name : post.prod_name,
            upc: post.upc,
            mrp: post.mrp,
            free_loose : post.free_loose,
            free_cld : post.free_cld,
            loose_to_be_picked: post.loose_to_be_picked,
            // free_product: post.free_product,
            
            to_be_picked_icld_qty:post.to_be_picked_icld_qty,
            dispatched_loose : post.dispatched_loose,
            
            dispatch_cld : post.dispatched_cld,
            
  
          }
  
        )
  
      });
  
      this.setState({
        loading_overlay: false,
        posts: posts ,
        filtered_orderData : posts,
        orderData : posts,
      })
  
      return posts;
  
    }
  
  processData() {

    this.setState({
      loading: true
    })

  }

  render() {
    const data = {

      columns: [
        {label: "Sr No.",
        field: "sr_no",
        sort: "asc",
        width: 70
      },
        {
          label: "Trip Id",
        field: "trip_id",
        sort: "asc",
        width: 100
      },
      {
        label: "Bill No",
      field: "bill_no",
      sort: "asc",
      width: 100
    },
      {
        label: "sku7_code",
        field: "sku7_code",
        width: 120,
        sort: "asc",
      },
      {
        label: "Product Name",
        field: "product_name",
        width: 150,
        sort: "asc",
      },
      {
        label: "upc",
        field: "upc",
        width: 120,
        sort: "asc",
      },
      {
        label: "MRP",
        field: "mrp",
        width: 110,
        sort: "asc",
      },
      {
        label: "Free Loose",
        field: "free_loose",
        width: 110,
        sort: "asc",
      },
      {
        label: "Free Cld",
        field: "free_cld",
        width: 110,
        sort: "asc",
      },
      {
        label: "Loose To Be Picked",
        field: "loose_to_be_picked",
        width: 110,
        sort: "asc",
      },
      {
        label: "Cld To Be Picked",
        field: "to_be_picked_icld_qty",
        width: 110,
        sort: "asc",
      },
      {
      label : "Dispatched Loose",
      field : "dispatched_loose",
      width: 120,
      sort : "asc"

      },

      {
        label : "Dispatched cld qty",
      field : "dispatch_cld",
      width: 120,
      sort : "asc"

      },
     

      ],

      rows: this.state.tableRows,

    }

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <CardBody style={{ paddingTop: 22, height: 100, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >

            <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="From Date"
                format='yyyy-MM-dd'

              />

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }
            </div>

            <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="To Date"
              />
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }

            </div>
            <div
                style={{width:'12%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Bill Number" onChange={this.onBillChange}/>
                </div>
              </div>
              <div
                style={{width:'12%',marginBottom:'0px', float: 'left', marginRight: 5}}
              >
                <div
                  className="form__form-group-field"
                   
                >
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "SubGroup Id" onChange={this.onSubGroupChange}/>
                </div>
              </div>
              
              
            

            <div style={{ width: '14%', marginBottom: '0px', marginLeft: "60px", float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={() => this.fetchInventoryData()}
                  // onClick={(e) => exportToCSV(this.state.filtered_orderData, "Billwise To Case Picksheet")}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                 View
                </Button>
                <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                // onClick={this.downloadReport}
              >

                {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Billwise To Case Picksheet", Heading)}  />
              </Button>
              </ButtonToolbar>
              
            </div>
            

          </form>
          </CardBody>
          <CardBody style={{ marginTop: 5 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Reports</h4>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Billwise Case Picksheet Report', 'datatable_pagination_change' )}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
              </CardBody>
          

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));